import { AppRouter } from "../core/router/AppRouter";

function App() {
  return <AppRouter />;
}

export default App;
